import * as yup from 'yup'

const signupFormValidationSchema = yup
  .object({
    name: yup.string().required('Name is required').min(3, 'Name should contain at least ${min} characters'),
    email: yup.string().trim().required('Email is required').email('Invalid email'),
    password: yup
      .string()
      .required('Password is required')
      .min(8, 'Password should contain at least ${min} characters'),
    rePassword: yup
      .string()
      .required('Password confirmation is required')
      .oneOf([yup.ref('password')], `Password doesn't match`),
    companyName: yup.string().required('Company Name is required'),
    activationCode: yup
      .string()
      .required('Activation code is required')
      .matches(/^ACTIVATE-[a-zA-Z0-9]+-([0-9]{2})([0-9]{2})$/, 'Invalid Activation Code')
  })
  .required()

export default signupFormValidationSchema
